"use client";

import { usePathname, useRouter } from "@/i18n/routing";
import clsx from "clsx";
import { useSearchParams } from "next/navigation";
import { useCallback } from "react";
import styles from "./tabBar.module.css";

interface ITab {
  name: string;
  label: string;
  disabled?: boolean;
  onClick?: () => void;
}

export interface ITabBarProps {
  tabs: ITab[];
}

export const TabBar = ({ tabs }: ITabBarProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const activeTab = searchParams.get("tab") || tabs[0].name;

  const updateActiveTab = useCallback(
    (tabName: string) => {
      router.push(`${pathname}?tab=${tabName}`);
    },
    [pathname, router],
  );

  return (
    <div className={styles.tabBar}>
      {tabs.map(({ name, label, disabled, onClick }) => {
        const isActive = name === activeTab;

        const handleTabClick = () => {
          if (disabled) return;

          if (onClick) {
            onClick();
          } else {
            updateActiveTab(name);
          }
        };

        return (
          <div
            key={name}
            className={clsx(
              styles.tab,
              isActive && styles.tab__active,
              disabled && styles.tab__disabled,
            )}
            onClick={handleTabClick}
          >
            {label}
          </div>
        );
      })}
    </div>
  );
};
